import { toggleIsLoading } from './loading';
import { browserHistory } from 'react-router';
import messageActions from './message'
import adminConstants from '../constants/admin';
import adminService from '../services/admin';
import vendorActions from './vendor';


const adminLogin = (data) => ({ type: adminConstants.LOGIN_ADMIN, data })
const adminLogout = () => ({ type: adminConstants.LOGOUT_ADMIN })
const adminForgotPassword = () => ({ type: adminConstants.FORGOT_PASSWORD_ADMIN })
const adminResetPassword = () => ({ type: adminConstants.RESET_PASSWORD_ADMIN })
const adminGetPhone = (data) => ({ type: adminConstants.GET_PHONE, data })
const adminConfirmEmail = (data) => ({ type: adminConstants.CONFIRM_EMAIL, data})

const adminCreate = (data) => ({ type: adminConstants.CREATE_ADMIN, data })
const adminUpdate = (data) => ({ type: adminConstants.UPDATE_ADMIN, data })
const adminDestroy = (adminId) => ({ type: adminConstants.DESTROY_ADMIN, adminId })

const adminActions = {}

adminActions.login = (data) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    adminService.login(data)
    .then((response) => {
      localStorage.setItem('token', response.apikey);
      dispatch(adminLogin(response));
      dispatch(vendorActions.list());
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(messageActions.setErrorMessage(err.message));
      dispatch(toggleIsLoading(false));
    })
  }
}

adminActions.logout = () => {
  return (dispatch) => {
    localStorage.removeItem('token');
    localStorage.removeItem('location_api_key');
    localStorage.removeItem('company_api_key');
    dispatch(adminLogout());
  }
}

adminActions.forgot = (data) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    adminService.forgot(data)
    .then((response) => {
      dispatch(messageActions.setSuccessMessage(response.message));
      dispatch(adminForgotPassword(response));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(messageActions.setErrorMessage(err.message));
      dispatch(toggleIsLoading(false));
    })
  }
}

adminActions.retrieve = (api_key, path=false) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    adminService.retrieve(api_key)
    .then((response) => {
      dispatch(adminLogin(response));
      dispatch(vendorActions.list(path));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(messageActions.setErrorMessage(err.message));
      dispatch(toggleIsLoading(false));
    })
  }
}

adminActions.reset = (data, router, prk) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    adminService.reset(data, prk)
    .then((response) => {
      dispatch(adminResetPassword(response));
      dispatch(messageActions.setSuccessMessage(response.message));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(messageActions.setErrorMessage(err.message));
      dispatch(toggleIsLoading(false));
    })
  }
}


adminActions.create = (data) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    adminService.create(data)
    .then((response) => {
      localStorage.setItem('token', response.apikey);
      dispatch(adminCreate(response));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

adminActions.update = (data) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    adminService.update(data)
    .then((response) => {
      localStorage.setItem('token', response.apikey);
      dispatch(adminUpdate(response));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

export default adminActions;



/** WEBPACK FOOTER **
 ** ./src/actions/admin.js
 **/